/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export var ReleaseStatus = {
    Approved: 'APPROVED',
    Denied: 'DENIED',
    Pending: 'PENDING'
};
export function ReleaseStatusFromJSON(json) {
    return ReleaseStatusFromJSONTyped(json, false);
}
export function ReleaseStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ReleaseStatusToJSON(value) {
    return value;
}
